import {
  Route,
  Routes,
  useLocation,
  useParams,
  useSearchParams,
} from 'react-router-dom';
import BenefitsPage from '../../Pages/BenefitsPage';
import CategoryPage from '../../Pages/CategoryPage';
import { queryParamKeys } from '../../Pages/CategoryPage/constants';
import RootCategoryTaxFilterWrapper from '../../Pages/Wrappers/RootCategoryTaxFilterWrapper';
import RootCategoryWrapper from '../../Pages/Wrappers/RootCategoryWrapper';
import { BenefitsPageProps } from '../../contexts/common';
import { TopLevelCategories } from '../../enums';

export const BenefitsRoutes = (props: { topLevelCategoryId: number }) => {
  return (
    <>
      <Routes>
        <Route
          path="/"
          element={
            <RootCategoryWrapper {...props}>
              <RootRouteHandler {...props} />
            </RootCategoryWrapper>
          }
        />
        <Route
          path="/:categoryId"
          element={
            <RootCategoryWrapper {...props}>
              <CategoryPageWithRemount {...props} />
            </RootCategoryWrapper>
          }
        />
      </Routes>
    </>
  );
};

// This component evaluates the condition after rootCategory is loaded
const RootRouteHandler = (props: BenefitsPageProps) => {
  const { topLevelCategoryId, rootCategory } = props;

  // Check if topLevelCategoryId is Cashback AND if rootCategory has no children
  const shouldShowCategoryPage =
    topLevelCategoryId === TopLevelCategories.Cashback &&
    rootCategory &&
    rootCategory.children?.length === 0;

  if (shouldShowCategoryPage) {
    return (
      <CategoryPageWithRemount
        {...props}
        forcedCategoryId={topLevelCategoryId.toString()}
      />
    );
  }

  return (
    <RootCategoryTaxFilterWrapper {...props}>
      <BenefitsPageWithRemount {...props} />
    </RootCategoryTaxFilterWrapper>
  );
};

// remounts the benefits page component every time the route changes, in order to reset the filters state
const BenefitsPageWithRemount = (props: BenefitsPageProps) => {
  const location = useLocation();
  return <BenefitsPage {...props} key={location.key} />;
};

// remounts the category page component every time the categoryId or (categoryId, brandId) changes, in order to reset the filters, sorting and paging state
const CategoryPageWithRemount = (props: BenefitsPageProps) => {
  const { categoryId } = useParams<{ categoryId: string }>();
  const actualCategoryId = props.forcedCategoryId || categoryId;
  const [searchParams] = useSearchParams();
  const brand = searchParams.get(queryParamKeys.brand);

  const key = brand
    ? `categoryId=${actualCategoryId},brand=${brand}`
    : `categoryId=${actualCategoryId}`;

  return <CategoryPage {...props} key={key} />;
};
